import { FC } from "react";

export const TeamPage: FC = () => null; // next PR
